<template>
  <div>
    <div class="flex-fill d-flex flex-column justify-content-center">
      <div class="container-tight py-6">
        <div class="text-center mb-4 mt-4">
          <a href="/"
            ><img
              :src="require('../../assets/images/logo-dark.png')"
              height="36"
              alt=""
          /></a>
        </div>
        <form class="card card-md" @submit.prevent="signin">
          <div class="card-body">
            <h2 class="mb-5 text-center">登入</h2>
            <div class="alert alert-danger" v-show="error" role="alert">
              {{ errorMsg }}
            </div>
            <div class="mb-3">
              <label class="form-label">Email</label>
              <input
                type="email"
                class="form-control"
                placeholder="Email"
                autocomplete="off"
                v-model="loginForm.email"
              />
            </div>
            <div class="mb-2">
              <label class="form-label">
                密碼
                <span class="form-label-description">
                  <router-link to="./forgetPassword">忘記密碼?</router-link>
                </span>
              </label>
              <div class="input-group input-group-flat">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  v-model="loginForm.password"
                />
              </div>
            </div>
            <div class="mb-2">
              <label class="form-check">
                <input type="checkbox" class="form-check-input" />
                <span class="form-check-label">記住我</span>
              </label>
            </div>
            <div class="form-footer">
              <button type="submit" class="btn btn-primary w-100">登入</button>
            </div>
          </div>
        </form>
        <div class="text-center text-muted mt">
          還沒有帳號? <router-link to="./signup">註冊</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      errorMsg: "",
      error: false,
    };
  },
  methods: {
    async signin() {
      if (this.loginForm.email == "" || this.loginForm.password == "") {
        this.error = true;
        this.errorMsg = "不得為空";
      } else {
        const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/account/login`;
        const vm = this;
        try {
          const res = await this.$http.post(api, vm.loginForm);
          Cookies.set("USD2PayToken", res.data.data.token, { expires: 1 });
          const response = await this.$http.get(
            `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me`,
            { headers: { Authorization: `Bearer ${res.data.data.token}` } }
          );
          if (response.data.status == "success") {
            Cookies.set("Usd2payInfo", btoa(response.data.data.email), {
              expires: 1,
            });
          } else {
            this.errorMsg = "錯誤";
          }
          vm.$router.push("dashboard");
        } catch (err) {
          this.error = true;
          this.errorMsg = "錯誤";
        }
      }
    },
  },
};
</script>

<style scoped>
.page {
  padding-top: 100px;
}
</style>
